import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'De forma inmediata en tu email tras el pago.'
}, {
  q: '¿Sirve para todo el país?',
  a: 'Sí, está diseñado bajo lineamientos NAP e INET nacionales.'
}, {
  q: '¿Se puede editar?',
  a: 'Los cuadernillos son PDF listos para imprimir. Las planificaciones (si se agregan) son editables.'
}, {
  q: '¿Es un solo pago?',
  a: 'Sí, un único pago por el acceso total.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-8 md:py-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-48">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-49">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-5 md:mb-8" data-id="element-50">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2 md:space-y-3" data-id="element-51">
          {faqs.map((faq, index) => <div key={index} className="bg-primary-card border border-primary-card rounded-xl overflow-hidden" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 md:px-6 py-3 md:py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-53">
                <span className="font-semibold text-base md:text-lg" data-id="element-54">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-accent-cyan transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>

              <AnimatePresence data-id="element-56">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-4 md:px-6 pb-3 md:pb-4 text-text-muted text-sm md:text-base" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </motion.div>
    </section>;
}